var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsideFavouriteIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7292 22.6771L14.5833 22.8229L14.4229 22.6771C7.49583 16.3917 2.91667 12.2354 2.91667 8.02083C2.91667 5.10417 5.10417 2.91667 8.02083 2.91667C10.2667 2.91667 12.4542 4.375 13.2271 6.35833H15.9396C16.7125 4.375 18.9 2.91667 21.1458 2.91667C24.0625 2.91667 26.25 5.10417 26.25 8.02083C26.25 12.2354 21.6708 16.3917 14.7292 22.6771ZM21.1458 0C18.6083 0 16.1729 1.18125 14.5833 3.03333C12.9938 1.18125 10.5583 0 8.02083 0C3.52917 0 0 3.51458 0 8.02083C0 13.5188 4.95833 18.025 12.4688 24.8354L14.5833 26.7604L16.6979 24.8354C24.2083 18.025 29.1667 13.5188 29.1667 8.02083C29.1667 3.51458 25.6375 0 21.1458 0Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideFavouriteIconDark);
export default __webpack_public_path__ + "static/media/aside-favourite-icon-dark.9b9a818bbc49cfc09ddba1b06425b31e.svg";
export { ForwardRef as ReactComponent };